import ClusterPlaneIconColor from '@shared/assets/ClusterPlaneIconColor';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Grid, Box, useTheme, Typography } from '@mui/material';

import { sxStyled } from './styles';
import SectionGrid from '@shared/components/SectionGrid';

const ClusterTitle = () => {
  const theme = useTheme();

  const customLayout = {
    xs: { 1: 1.3, 2: 2.3, 3: 3, 4: 3, 5: 2.4 },
  };

  return (
    <SectionGrid
      spacing={1}
      padding="8px"
      customLayout={customLayout}
      gridSx={{ alignItems: 'center' }}
    >
      <Box />
      <Typography
        sx={{
          color: '#000',
          fontWeight: 600,
          fontSize: '15px',
        }}
      >
        Salida
      </Typography>

      <Typography
        sx={{
          color: theme.tertiary,
          fontWeight: 600,
          fontSize: '15px',
        }}
      >
        Duración
      </Typography>

      <Typography
        sx={{
          color: '#000',
          fontWeight: 600,
          fontSize: '15px',
        }}
      >
        Escala
      </Typography>

      <Typography
        sx={{
          color: '#000',
          fontWeight: 600,
          fontSize: '15px',
        }}
      >
        Equipaje
      </Typography>
    </SectionGrid>
  );
};

const FlightTitle = ({
  element,
  indexLeg,
  elementLeg,
  isMobile = false,
  id,
}) => {
  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  return (
    <Grid
      item
      id={id}
      sm={element.combinations[0].next_leg_options ? 6 : 12}
      xs={12}
      sx={sxStyle.gridClusterItem}
      style={{ marginTop: isMobile ? '20px' : '0px' }}
    >
      <Box
        style={{
          background: '#E5E5E5',
          borderRadius: '8px',
          width: '100%',
        }}
      >
        <Box sx={sxStyle.boxClusterTitleIda}>
          <ClusterPlaneIconColor
            id="flight-title-plane-icon"
            color={theme.tertiary}
            rotate={indexLeg === 1 ? 180 : 0}
            boxSx={{
              pr: { xs: 1 },
            }}
          />
          &nbsp;&nbsp;
          <Typography
            style={{
              color: theme.tertiary,
              fontWeight: 600,
              fontSize: '16px',
            }}
          >
            {elementLeg?.title?.toUpperCase()}
          </Typography>
          &nbsp;&nbsp;
          <Typography
            style={{
              color: '#000',
              fontSize: '15px',
            }}
          >
            {elementLeg?.short_date}
          </Typography>
        </Box>
      </Box>

      <Box sx={sxStyle.boxSalida}>
        <ClusterTitle />
        <div
          aria-disabled={false}
          aria-hidden={true}
          style={{
            cursor: 'default',
            padding: '0px 1px',
          }}
        >
          <span className="MuiIconButton-label">
            <ExpandMoreIcon
              style={{
                color: '#FFF',
              }}
            />
          </span>
          <span className="MuiTouchRipple-root"></span>
        </div>
      </Box>
    </Grid>
  );
};

export default FlightTitle;
